import React, { useState, useEffect } from "react";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Expenses from "./pages/Expenses";

const BACKEND = process.env.REACT_APP_BACKEND_URL || "http://localhost:5002";

export default function App() {
  const [user, setUser]       = useState(null);
  const [loading, setLoading] = useState(true);
  const [page, setPage]       = useState("dashboard");

  useEffect(() => {
    fetch(`${BACKEND}/auth/me`, { credentials: "include" })
      .then(r => { if (!r.ok) { setLoading(false); return; } return r.json(); })
      .then(data => { if (data?.id) setUser(data); })
      .catch(() => setUser(null))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return (
    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100vh", background: "#faf7f2" }}>
      <div style={{ fontFamily: "Fraunces, serif", fontSize: "22px", color: "#2d6a4f" }}>🌱</div>
    </div>
  );

  if (!user) return <Login />;

  return page === "expenses"
    ? <Expenses user={user} onNavigate={setPage} />
    : <Dashboard user={user} onNavigate={setPage} />;
}